// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__2thnl","contentBar":"styles_contentBar__1F0aq","removePadding":"styles_removePadding__3aU7a","rightSideBlock":"styles_rightSideBlock__2pGQK"};